<template>
  <div class="pd-10" :class="widgetTrackplusFlag ? 'col-xs-12 col-sm-6 col-md-4' : ''">
    <div class="summary-card" :class="widgetTrackplusFlag ? 'widget-1' : ''">
      <div class="col-xs-12 title d-flex">
        <!-- <img src="/static/images/icons/documents.svg" class="track_plus_icon_blue" /> -->
        <span class="summary_title">{{ $t('complianceDataLabel') }}</span>
      </div>
      <div class="certification_message" :class="$i18n.locale === 'Portuguese' && 'certificate-message-lh-pr'">{{ $t('certificationMessage') }}</div>
      <div class="col-md-12 col-xs-12 summary_row">
        <div class="summary col-md-12 col-xs-12">
          <div class="div-img">
            <!-- <img class="summary_registration" src="/static/images/icons/devices.svg" /> -->
            <div class="rounded_corner"><span id="item_number">{{ devicesCount }}</span></div>
          </div>
          <div class="col-xs-12 heading" :class="$i18n.locale === 'Portuguese' && 'heading-lh-pr'">
            {{ $t('products') }}
            <div class="expire_time">{{ $t('totalProductCount') }}</div>
            <!-- <span class="border border-primary"></span> -->
          </div>
        </div>
      </div>
      <div class="col-md-12 col-xs-12 summary_row">
        <div class="summary col-md-12 col-xs-12">
          <div class="div-img">
            <!-- <img class="summary_registration" src="/static/images/icons/location.svg" /> -->
            <div class="rounded_corner"><span id="item_number">{{ countriesCount }}</span></div>
          </div>
          <div class="col-xs-12 heading" :class="$i18n.locale === 'Portuguese' && 'heading-lh-pr'">
            {{ $t('countryOfOrigin') }}
              <div class="expire_time">{{ $t('totalCountryofOriginCount') }}</div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-xs-12 summary_row">
        <div class="summary col-md-12 col-xs-12 ">
          <div class="div-img">
            <div class="rounded_corner"><span id="item_number">{{ registrationCount }}</span></div>
          </div>
          <div class="col-xs-12 heading" :class="$i18n.locale === 'Portuguese' && 'heading-lh-pr'">
            {{ $t('certificates') }}
              <div class="expire_time"> {{ $t('totalCertificateCount') }}</div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 footer p-0">
        <div class="col-xs-12 p-0">
           <button type="button" class="btn view_all_button" @click="viewAll()">
           <span class="seeMore pr-8" >{{ $t('viewAll') }}</span>
            <img src="/static/images/icons/Back.svg" class="pl-10 pb-3" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['widgetTrackplusFlag', 'registrationCount', 'devicesCount', 'countriesCount', 'panel'],
  methods: {
    goToLink(link) {
      this.$router.push(link);
    },
    viewAll() {
      this.$router.push('/layout/registration');
    },
  },
};
</script>

<style scoped>
.certificate-message-lh-pr {
  line-height: 21px !important;
}
.heading-lh-pr {
  line-height: 19px !important;
}
.expire_time {
  font-size: 14px;
  color: #3E3E3E;
}
.div-img {
  margin-top: -13px;
}
#item_number {
  width: 25%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: #333333;
}
.rounded_corner {
  border-radius: 25px;
  border: 2px solid #B4B4B4;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  background: #FFFFFF;
  box-shadow:1.62162px 1.62162px 4.05405px rgba(0, 0, 0, 0.12);
  /* margin-top:5px */
  padding: 4px 10px 4px 10px;
}
.compliance-icons{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 12px;
}
.view_all_button,
.view_all_button:hover {
  background-color: #01518A;
  height: 34px;
  width: 123px;
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 600;
  border-radius: 3px;
  line-height: 22px;
  float: right;
  cursor: pointer;
  padding: 6px 20px 6px 16px;
}
.compliance-labels {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #01518A;
}
.d-flex {
  display: flex;
}

.jc-end {
  justify-content: flex-end;
}

.mb--10 {
  margin-bottom: -10px;
}

.mt-10 {
  margin-top: 10px;
}
.pt-16 {
  padding-top:16px;
}
.pt-5 {
  padding-left:16px;
}
.pr-4 {
  padding-right:4px;
}
.pl-17 {
  padding-left:17px;
}
.pl-12 {
  padding-left:12px
}
.pl-10 {
  padding-left:10px
}
.pl-6 {
  padding-left:6px
}
.pl-4 {
  padding-left:4px
}

.pt-20 {
  padding-top: 20px;
}

.footer {
  padding-right: 8px;
  padding-left: 20px;
  position: absolute;
  bottom: 8px;
  right: 0px;
}

.seeMore {
  /* font-size: 18px; */
  color: #FFFFFF;
  /* float: right;
  cursor: pointer;
  font-weight: 700;
  line-height: 25px; */
}

/* .widget-1 {
  padding: 10px 16px 25px 16px;
  min-height: 376px;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  background: #ffffff;
} */
/* .summary_line {
  border-bottom: 0.7px solid #BDBDBD;
  padding-bottom: 46px;

} */
.dashboard-trackplus-cards .summary_row {
  padding-top: 14px;
  padding-bottom: 10px;
  border-bottom: none !important;
}

.dashboard-trackplus-cards .summary_row:first-of-type {
  padding-top: 14px;
}

.summary_row {
  display: flex;
  flex-direction: row;
  padding-bottom: 22px;
  padding-left: 0px;
  padding-right: 0px;
  /* padding-left:11px */
}

.summary_main {
  display: flex;
  flex-direction: column;
}

.summary_title {
  font-weight: 300;
  font-size: 24px;
  line-height: 33px;
  color: #3E3E3E;
  /* padding-left: 9px */
}

/* .summary_row:not(:last-child) {
  border-bottom: 0.7px solid #BDBDBD;
} */
.dashboard-trackplus-cards .track_plus_icon_blue {
  width: 32px;
  height: 32px;
}

.summary {
  display: flex;
  align-items: center;
  padding-left: 0px;
  padding-right: 0px;
}

.dashboard-trackplus-cards .title {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 26px;
  color: #0B3C61;
  padding-left: 24px;
  margin-top: 0px;
  padding-top: 17px;
}

.title {
  padding-left: 2px;
  /* border-bottom: 0.5px solid #B4B4B4; */
  padding-bottom: 33px;
  /* margin-bottom: 16px; */
}

.dashboard-trackplus-cards .heading,
.dashboard-trackplus-cards .heading_count {
  font-weight: 400;
  font-size: 20px;
}

.heading {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #01518A;
  display: inline;
  margin-top: -2px;
}

.heading_count {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 26px;
  color: #333333;
  float: right;
  margin-right: -17px;
  margin-top: 2px;
}

.cursor_pointer {
  cursor: pointer !important;
  word-break: break-all;
  white-space: normal;
}

.certification_message {
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  color: #3E3E3E;
  /* padding-left: 9px; */
  padding-bottom: 22px;

}

.summary_registration {
  width: 24px;
  height: 24px;
}

@media screen and (max-width: 767px) {
  .content-wrappper .widget-1 {
    margin-bottom: 20px !important;
  }

  .heading {
    padding-right: 0px;
  }
}
</style>
